<!--告警弹窗，全局性组件-->
<template>
<div class="WarningWindow" v-if="showWarningWindow">
  <div class="title-line-container">
    <div class="urgency-level">{{warningEventList[warningIndex].urgencyLevel}}</div>
    <div class="event-name">{{warningEventList[warningIndex].warningEventName}}</div>
    <div class="warning-number-container">{{"("+(warningIndex+1)+"/"+warningEventList.length+")"}}</div>
    <div class="btn-close" @click.stop="onCLickCancel">×</div>
  </div>
  <div class="time-line-container">{{warningEventList[warningIndex].deviceName}} | {{warningEventList[warningIndex].time}}</div>
  <div class="warning-content-container">{{warningEventList[warningIndex].content}}</div>
  <div class="btn-container">
    <div :class="{'btn-disabled':warningIndex===0}" @click.stop="onClickPreOne">上一条</div>
    <div :class="{'btn-disabled':warningIndex===warningEventList.length-1}" @click.stop="onClickNextOne">下一条</div>
    <div @click.stop="onClickViewDetail">查看详情</div>
  </div>
</div>
</template>
<script>


export default ({
  name: "WarningWindow",
  data() {
    return {
      warningIndex: 0,       // 告警事件下标
    }
  },
  mounted() {

  },
  computed: {
    alarmMessageList() {
      //告警消息列表
      return this.$store.state.alarmMessageList;
    },
    showWarningWindow() {
      // 是否展示告警弹窗
      let alarmMessageList = this.$store.state.alarmMessageList;
      return alarmMessageList !== undefined && alarmMessageList !== null && alarmMessageList.length > 0;
    },
    warningEventList() {
      //告警事件消息列表
      return this.$store.state.alarmMessageList;
    }
  },
  watch:{
    alarmMessageList(){
      this.warningIndex = 0;
    }
  },
  methods: {
    onCLickCancel() {
      // 清空store中的消息列表
      this.$store.commit('SET_ALARM_MESSAGE_LIST', []);
      this.warningIndex = 0;  // 下标置为0
    },
    onClickPreOne() {
      // 显示上一条告警事件的消息
      if(this.warningIndex > 0) {
        this.warningIndex--;
      }
    },
    onClickNextOne() {
      // 显示下一条告警事件的消息
      if(this.warningIndex !== this.warningEventList.length - 1) {
        this.warningIndex++;
      }
    },
    onClickViewDetail() {
      // 跳转到告警管理
      console.log("点击了查看详情");
      this.$router.push("/alarmManagement/alarmManagement");

    },
  }
})
</script>



<style scoped lang="less">
.WarningWindow {
  z-index: 999;
  width: 560px;
  border: 1px solid #FFE58F;
  position: absolute;
  bottom: 80px;
  right: 50px;
  background: #FFFBE6;
  padding: 10px;
  > div:not(:first-child) {
    margin-top: 5px;
  }
}
.title-line-container{
  display: flex;
  align-content: center;
  .urgency-level{
    color: #F5222D;
    background: #FFF1F0;
    border: 1px solid #F5222d;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-content: center;
    padding: 0 8px;
  }
  .event-name{
    margin-left: 0.5em;
    flex: 1;
    display: flex;
    align-items: center;
    font-weight: bold;
  }
  .warning-number-container{
    color: #8C8C8C;
    margin-left: 8px;
    margin-right: 8px;
    display: flex;
    align-items: center;
  }
  .btn-close{
    font-size: 16px;
    margin-left: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.time-line-container{
  color: #8C8C8C;
  font-size: 14px;
  font-weight: 400;
}
.warning-content-container{
  font-size: 14px;
  font-weight: 400;
  color: rgba(0,0,0,85%);
}
.btn-container{
  font-size: 14px;
  font-weight: 400;
  > div{
    display: inline-block;
    color: #E4747E;
    cursor: pointer;

    -webkit-user-select: none; /* Chrome, Safari, Opera */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* 标准语法 */
  }
  >div:not(:first-child) {
    margin-left: 8px;
  }
  .btn-disabled{
    cursor: default;
    color: #D9D9D9;
  }
}
</style>
